/* tslint:disable */
/* eslint-disable */
/**
 * Property Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.0.2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BaseCustomAttributeOut
 */
export interface BaseCustomAttributeOut {
    /**
     * 
     * @type {string}
     * @memberof BaseCustomAttributeOut
     */
    offerId: string;
    /**
     * 
     * @type {string}
     * @memberof BaseCustomAttributeOut
     */
    code: string;
    /**
     * 
     * @type {string}
     * @memberof BaseCustomAttributeOut
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof BaseCustomAttributeOut
     */
    dataTypeCode: string;
    /**
     * 
     * @type {boolean}
     * @memberof BaseCustomAttributeOut
     */
    isVisible?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof BaseCustomAttributeOut
     */
    modificationDate: Date;
    /**
     * 
     * @type {string}
     * @memberof BaseCustomAttributeOut
     */
    baseUnitOfMeasureCode?: string;
    /**
     * 
     * @type {number}
     * @memberof BaseCustomAttributeOut
     */
    attributeId: number;
}

export function BaseCustomAttributeOutFromJSON(json: any): BaseCustomAttributeOut {
    return BaseCustomAttributeOutFromJSONTyped(json, false);
}

export function BaseCustomAttributeOutFromJSONTyped(json: any, ignoreDiscriminator: boolean): BaseCustomAttributeOut {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'offerId': json['offerId'],
        'code': json['code'],
        'name': json['name'],
        'dataTypeCode': json['dataTypeCode'],
        'isVisible': !exists(json, 'isVisible') ? undefined : json['isVisible'],
        'modificationDate': (new Date(json['modificationDate'])),
        'baseUnitOfMeasureCode': !exists(json, 'baseUnitOfMeasureCode') ? undefined : json['baseUnitOfMeasureCode'],
        'attributeId': json['attributeId'],
    };
}

export function BaseCustomAttributeOutToJSON(value?: BaseCustomAttributeOut | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'offerId': value.offerId,
        'code': value.code,
        'name': value.name,
        'dataTypeCode': value.dataTypeCode,
        'isVisible': value.isVisible,
        'modificationDate': (value.modificationDate.toISOString()),
        'baseUnitOfMeasureCode': value.baseUnitOfMeasureCode,
        'attributeId': value.attributeId,
    };
}


